import React from '../helpers/react';
import Problem from '../components/Problem.js';
import ReviewBox from '../components/ReviewBox.js';

export const ProblemContainer = React.createClass({
    render : function(){
        return (
            <div>
                <Problem key='problem' />
                <ReviewBox key='review-box' />
            </div>
        )
    }
});

export default ProblemContainer;


// WEBPACK FOOTER //
// ./src/containers/ProblemContainer.js